// extracted by mini-css-extract-plugin
module.exports = {"fix":"CI","modal":"DI","modalContent":"EI","header":"FI","footer":"GI","cancelBtn":"HI","disabled":"II","formWrapper":"JI","fade":"KI","fade-in":"LI"};